/** Utility to see if the valueToMatch is included in the arrayItem.
 */
export var matchSelectedValue = function matchSelectedValue(valueToMatch) {
  return function (arrayItem) {
    return typeof arrayItem === 'string' ? arrayItem === valueToMatch : arrayItem.value === valueToMatch;
  };
};